import React, { useState, useEffect } from 'react';
import EstateLoading from "./estateOriginality/EstateLoading";
const CarLoading=({progress})=>{
    return <div className="car-loading">
        <svg id="car-svgrepo-com_4_" data-name="car-svgrepo-com (4)" xmlns="http://www.w3.org/2000/svg" width="100.048" height="50.08" viewBox="0 0 906.048 486.08">
            <path id="Path_1" data-name="Path 1" d="M966.208,508.736c-80.576,0-152.448,32.128-199.232,82.176" transform="translate(-762.432 -295.744)" fill="#aebcc3"/>
            <path id="Path_2" data-name="Path 2" d="M970.752,684.992c-10.816,19.2-32.064,32.192-56.576,32.192H129.536c-35.84,0-64.832-27.648-64.832-61.76V638.016h36.608a15.744,15.744,0,0,0,16.064-15.3V550.912a277.569,277.569,0,0,1,150.144-44.16h-1.6l55.04-.256c53.632-115.2,157.5-210.752,294.208-210.752,136.512,0,251.008,89.728,282.176,210.688h16.832c35.456,0,56.128,27.392,56.128,61.184" transform="translate(-64.704 -295.744)" fill="#2563eb"/>
            <path id="Path_3" data-name="Path 3" d="M118.528,654.464h-13.76A39.168,39.168,0,0,1,64.7,616.192v-17.6c0-21.12,17.92-38.208,40.064-38.208h13.376" transform="translate(787.52 -295.744)" fill="#f5bb1d"/>
            <path id="Path_4" data-name="Path 4" d="M363.264,684.992c0,53.479-45.5,96.832-101.632,96.832S160,738.471,160,684.992s45.5-96.832,101.632-96.832,101.632,43.353,101.632,96.832Z" transform="translate(447.488 -295.744)" fill="#455963"/>
            <path id="Path_5" data-name="Path 5" d="M304.384,684.992c0,22.516-19.141,40.768-42.752,40.768s-42.752-18.252-42.752-40.768,19.141-40.768,42.752-40.768S304.384,662.476,304.384,684.992Z" transform="translate(447.488 -295.744)" fill="#aebcc3"/>
            <path id="Path_6" data-name="Path 6" d="M855.168,684.992c0,53.479-45.474,96.832-101.568,96.832s-101.568-43.353-101.568-96.832S697.506,588.16,753.6,588.16s101.568,43.353,101.568,96.832Z" transform="translate(-536.448 -295.744)" fill="#455963"/>
            <path id="Path_7" data-name="Path 7" d="M796.416,684.992c0,22.516-19.141,40.768-42.752,40.768s-42.752-18.252-42.752-40.768,19.141-40.768,42.752-40.768S796.416,662.476,796.416,684.992Z" transform="translate(-536.576 -295.744)" fill="#aebcc3"/>
            <path id="Path_8" data-name="Path 8" d="M922.56,591.1v-.192a257.92,257.92,0,0,1,48.192-40V622.72c0,8.448-7.232,15.3-16.064,15.3H918.08v-42.3Z" transform="translate(-918.08 -295.744)" fill="#f5bb1d"/>
            <path id="Path_9" data-name="Path 9" d="M445.7,335.616c104.9,6.336,191.3,76.8,216.64,170.816H445.7ZM405.568,506.432H188.928c41.216-86.848,117.12-159.616,216.64-170.048V506.432Z" transform="translate(119.488 -295.744)" fill="#ececec"/>
        </svg>
    </div>

}
function ProgressBar({ duration,theme,type,message='لطفا منتظر بمانید'}) {
    const [progress, setProgress] = useState(0);

    useEffect(() => {
        const totalTicks = duration;
        let tick = 0;

        const intervalId = setInterval(() => {

            tick++;
            setProgress((tick / totalTicks) * 100);

            if (tick >= totalTicks) {
                clearInterval(intervalId);
            }
        }, 1000); // Update every second

        return () => {
            clearInterval(intervalId);
        };
    }, [duration]);

    return (
        <div className="flex flex-col justify-center h-screen  items-center">
            {type==="CService" && <CarLoading progress={progress} />}
            {type==="Estate" && <EstateLoading progress={progress} />}
            <div className="progress-bar h-2 bg-gray-100 relative rounded-xl ">
                <div className="w-full h-2 bg-white border border-gray-100 rounded-xl"></div>
                <div className={`progress text-xs text-white h-2 top-0 absolute ${theme ? `bg-${theme}-600` :'bg-blue-600'} rounded-xl`} style={{ width: `${progress}%` }}/>

            </div>
            <div className="w-full flex justify-center">
                <span className="w-full text-center mt-3  text-sm">{message}</span>
            </div>
        </div>
    );
}

export default ProgressBar;